export const moduleName = 'auth';

export const forms = {
    login: 'login',
};

const loginFields = {
    email: 'email',
    password: 'password',
};

export const formFields = {
    [forms.login]: loginFields,
};
